import React from 'react';
import { ShieldCheck, ShieldAlert, ShieldX } from 'lucide-react';

const WarrantyBadge = ({ warrantyExpiry }) => {
  if (!warrantyExpiry) {
    return <span className="text-xs text-gray-400">N/A</span>;
  }

  const now = new Date();
  const expiry = new Date(warrantyExpiry);
  const threeMonthsFromNow = new Date();
  threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);

  if (expiry < now) {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-red-600 bg-red-50 px-2 py-0.5 rounded-full">
        <ShieldX size={12} />
        Expirée
      </span>
    );
  }

  if (expiry < threeMonthsFromNow) {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-orange-600 bg-orange-50 px-2 py-0.5 rounded-full">
        <ShieldAlert size={12} />
        Expire bientôt
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
      <ShieldCheck size={12} />
      Valide
    </span>
  );
};

export default WarrantyBadge;
